var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCefta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M9.98 11.8h-2.2v1.38h2.2a5.07 5.07 0 0 0 8.6 2.9l-.92-.93a3.75 3.75 0 0 1-6.43-2.66 3.76 3.76 0 0 1 6.03-3.01l.86.86 1.94-1.94-.97-.97-1.03 1.03a5 5 0 0 0-2.37-.99V2.43h-1.37v5.04a5.1 5.1 0 0 0-4.34 4.34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M25.16 11.8h-4.42v1.38h4.42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M16.53 10.96a2.16 2.16 0 0 0-3.7 1.53 2.17 2.17 0 0 0 3.7 1.53l-.91-.91a.87.87 0 0 1-1.49-.62.87.87 0 0 1 1.49-.62z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M10.26 8.67a.69.69 0 1 0 0-1.38.69.69 0 0 0 0 1.38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M6.22 13.18a.69.69 0 1 0 0-1.38.69.69 0 0 0 0 1.38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M15 19.76a.69.69 0 1 0 0-1.38.69.69 0 0 0 0 1.38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M15 21.96a.69.69 0 1 0 0-1.37.69.69 0 0 0 0 1.37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M19.42 13.18a.69.69 0 1 0 0-1.38.69.69 0 0 0 0 1.38"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m10.39 16.1-.98.97.98.98.97-.98z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "m20.63 17.15-.98.98.98.96.97-.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCefta);
export default __webpack_public_path__ + "static/media/cefta.846dd3533b0e932877fad4e6c8a0cc1b.svg";
export { ForwardRef as ReactComponent };